import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-multi-carousel/lib/styles.css";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import store from "./Redux/Store";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Polyfill crypto.randomUUID for local network IP access on mobile (http://192.168.x.x)
if (typeof window !== "undefined") {
  if (!window.crypto) {
    window.crypto = {};
  }
  if (!window.crypto.randomUUID) {
    window.crypto.randomUUID = () => {
      return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
          c ^
          ((window.crypto.getRandomValues
            ? window.crypto.getRandomValues(new Uint8Array(1))[0]
            : Math.floor(Math.random() * 256)) &
            (15 >> (c / 4)))
        ).toString(16)
      );
    };
  }
}

ReactDOM.render(
  <>
    <Helmet>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />
    </Helmet>
    <BrowserRouter basename="">
      <ToastContainer hideProgressBar={true} />
      <Provider store={store}>
        <Toaster
          position="bottom-center"
          containerStyle={{
            top: 20,
            left: 20,
            bottom: 60,
            right: 20,
          }}
          toastOptions={{
            style: {
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
            },
          }}
        />
        <App />
      </Provider>
    </BrowserRouter>
  </>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
